module.exports = __webpack_public_path__ + "static/media/protection_professionnels.5957c470.png";